export const OBTER_ATUALIZACOES = 'OBTER_ATUALIZACOES'
export const INICAR_ATUALIZACAO = 'INICAR_ATUALIZACAO'
export const EFETUAR_DOWNLOAD_EXCEL = 'EFETUAR_DOWNLOAD_EXCEL'
export const FILTRAR_ATUALIZACAO = 'FILTRAR_ATUALIZACAO'
export const EFETUAR_DOWNLOAD_RECEITA ='EFETUAR_DOWNLOAD_RECEITA'